import { useState } from "react";

const UploadFile = (props) => {
  const [uploadName, setUploadName] = useState(null);
  // Create unique ID based on uploadName prop to avoid conflicts when multiple instances exist
  const inputId = `upload-file-${props.uploadName || "default"}`;
  
  return (
    <div className="uploadLogoContainer">
      <div className="uploadContainer">
        <input
          type="file"
          id={inputId}
          name={props.uploadName}
          hidden
          onChange={(e) => {
            if (e.target.files && e.target.files[0]) {
              setUploadName(e.target.files[0].name);
            }
            props.onChange(e);
          }}
          onBlur={props.onBlur}
        />

        <label htmlFor={inputId}>UPLOAD</label>
        <span id={`fileChosen-${props.uploadName || "default"}`}>{uploadName || props.placeholder}</span>
      </div>
    </div>
  );
};

export default UploadFile;
